import { Component, OnInit } from '@angular/core';
import { version } from "@env/environment";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public ver = version;

  constructor() { }

  ngOnInit() {
  }

}
